module.exports = __webpack_public_path__ + "media/images/landing_page/screen_pc-3d837b124c33ccb658c04cbe147e1707.png";